import React from "react";
import { useNavigate } from "react-router-dom";
import { LegalLayout, Section } from "@/components/LegalLayout";
import { Button } from "@/components/ui/button";
import { Store, Camera } from "lucide-react";

export default function About() {
  const navigate = useNavigate();
  return (
    <LegalLayout
      metaTitle="About Nearfluence — Local influence, real connections"
      metaDescription="Nearfluence helps UK businesses and content creators discover each other, connect and collaborate — from independent local businesses to growing brands."
      title="About Nearfluence"
      subtitle="Local influence. Real connections."
    >
      <Section>
        <p>Nearfluence is a platform designed to make it easier for businesses and content creators to discover each other, connect and collaborate.</p>
        <p>For businesses, finding the right creator can be difficult. Large follower counts do not always mean the right audience, and finding relevant creators in the right location can take time.</p>
        <p>For creators, finding genuine opportunities with businesses can be equally difficult — particularly for those still growing their audience, who may have highly engaged followers but are often overlooked.</p>
        <p><b>Nearfluence brings both sides together.</b></p>
        <p>Businesses can discover creators based on factors such as location, interests, platforms and audience information, or publish opportunities for creators to discover and apply for.</p>
        <p>Creators can build a profile, showcase their social presence, discover collaboration opportunities and receive invitations directly from businesses.</p>
      </Section>
      <Section title="Our aim is simple">
        <p>Make creator marketing more accessible, local and straightforward.</p>
        <p>Nearfluence is designed to support creators and businesses across the United Kingdom — whether you're a creator just beginning to grow your audience or one with millions of followers, and whether you're an independent local business or a growing brand. Everyone is welcome, and no creator is defined by their follower count.</p>
      </Section>
      <div className="mt-6 flex flex-wrap gap-3">
        <Button data-testid="about-join-creator" onClick={() => navigate("/auth?mode=register&role=creator")} className="rounded-full bg-emerald-600 hover:bg-emerald-700"><Camera className="mr-2 h-4 w-4" /> Join as a Creator</Button>
        <Button data-testid="about-join-business" onClick={() => navigate("/auth?mode=register&role=business")} variant="outline" className="rounded-full border-2 border-zinc-900"><Store className="mr-2 h-4 w-4" /> Join as a Business</Button>
      </div>
    </LegalLayout>
  );
}
